import BaseService from './_base.service';

export const foroService = {
    page,
    search,
    edit,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/foro/page/"+page+"/"+size, callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/foro/page/"+page+"/"+size,filter, callback, true)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/foro/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/foro/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/foro/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/foro/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/foro/"+id+"/logic", callback);
}
